export function uri(strings, ...keys) {
    return (params) => {
      const dict = params || {}
      let result = strings[0]
      keys.forEach((key, i) => {
        result += encodeURIComponent(dict[key] || '') + strings[i + 1]
        delete dict[key]
      })
      return result
    }
}